import api from '@/utils/api'
import STATUS from '@/utils/status'
import Vue from 'vue'
import _ from 'lodash'

let state = {
  notifications: {},
  nextId: 0
}

let mutations = {
  clean (state) {
    state.notifications = {}
    state.nextId = 0
  },
  getEditableDataFor (state, groupId) {
    if (!state.notifications[groupId]) {
      Vue.set(state.notifications, groupId, {
        aggregates: [],
        hasNew: false,
        status: STATUS.IDLE,
        lastTime: -1,
        lastPromise: null,
        afterTime: null,
        afterStatus: STATUS.LOADED
      })
    }
    return state.notifications[groupId]
  },
  addAggregates (state, {groupId, aggregates, inFront = false}) {
    let aggs = state.notifications[groupId].aggregates
    if (inFront) {
      aggregates = _.reverse(_.clone(aggregates))
    }
    aggregates.forEach((a) => {
      a.id = state.nextId++
      if (a.type === 'groupProfile') {
        a.objects = [a.group]
      }
      if (a.action === 'AcceptInvit') {
        a.objects = [a.author]
      }
      if (!inFront) {
        aggs.push(a)
      } else {
        aggs.unshift(a)
      }
    })
  },
  setStatus (state, {groupId, status}) {
    state.notifications[groupId].status = status
  },
  setLastTime (state, {groupId, lastTime}) {
    state.notifications[groupId].lastTime = lastTime
  }
}

let actions = {
  clean (ctx) {
    ctx.commit('clean')
  },
  loadFor (ctx, groupId) {
    ctx.commit('getEditableDataFor', groupId)
    let data = ctx.state.notifications[groupId]
    let lp = data.lastPromise
    if (lp) {
      return lp
    }
    data.lastPromise = new Promise((resolve, reject) => {
      if (data.status === STATUS.IDLE) {
        data.status = STATUS.LOADING
        api.get('notifications', {params: {group: groupId}}).then((response) => {
          ctx.commit('addAggregates', {groupId, aggregates: response.data.aggregate})
          ctx.commit('setStatus', {groupId, status: STATUS.LOADED})
          ctx.commit('setLastTime', {groupId, lastTime: response.data.lastTime})
          data.afterTime = response.data.afterTime
          resolve(data)
        }).catch(reject)
      } else if (data.status === STATUS.LOADING) {
        data.lastPromise.then(resolve).catch(reject)
      } else if (data.status === STATUS.LOADED) {
        if (data.afterStatus === STATUS.LOADED) {
          data.afterStatus = STATUS.LOADING
          api.get('notifications', {params: {group: groupId, after: data.afterTime}}).then((response) => {
            ctx.commit('addAggregates', {groupId, aggregates: response.data.aggregate, inFront: true})
            data.afterStatus = STATUS.LOADED
            // ctx.commit('setLastTime', {groupId, lastTime: response.data.lastTime})
            data.afterTime = response.data.afterTime
            resolve(data)
          }).catch(reject)
        }
      }
    }).finally(() => { data.lastPromise = null })
  },
  loadMore (ctx, groupId) {
    ctx.commit('getEditableDataFor', groupId)
    let data = ctx.state.notifications[groupId]
    let lp = data.lastPromise
    if (lp) {
      return lp
    }
    data.lastPromise = new Promise((resolve, reject) => {
      if (data.status === STATUS.LOADED) {
        data.status = STATUS.LOADING_MORE
        if (data.lastTime) {
          api.get('notifications', {params: {group: groupId, before: data.lastTime}}).then((response) => {
            if (response.data.aggregate.length === 0) {
              data.lastTime = null
              if (groupId.indexOf('-2') > -1 || groupId.indexOf('-1') > -1) {
                ctx.commit('addAggregates', {groupId,
                  aggregates: [{
                    type: 'account',
                    author: ctx.rootGetters['user/user'],
                    action: 'Add',
                    objects: [ctx.rootGetters['user/user']],
                    firstTime: ctx.rootGetters['user/user'].creationTime
                  }]})
              }
            } else {
              ctx.commit('addAggregates', {groupId, aggregates: response.data.aggregate})
              data.lastTime = response.data.lastTime
            }
            data.status = STATUS.LOADED
            resolve(data)
          }).catch(reject)
        } else {
          resolve(data)
        }
      }
    }).finally(() => { data.lastPromise = null })
  },
  setHasNew (ctx, {groupId, status}) {
    ctx.commit('getEditableDataFor', groupId)
    let data = ctx.state.notifications[groupId]
    data.hasNew = status
  }
}

let getters = {
  statusFor (state) {
    return (groupId) => {
      return state.notifications[groupId] && state.notifications[groupId].status
    }
  },
  afterTimeFor (state) {
    return (groupId) => {
      return state.notifications[groupId] && state.notifications[groupId].afterTime
    }
  },
  afterStatusFor (state) {
    return (groupId) => {
      return state.notifications[groupId] && state.notifications[groupId].afterStatus
    }
  },
  hasNewFor (state) {
    return (groupId) => {
      return state.notifications[groupId] && state.notifications[groupId].hasNew
    }
  },
  aggregatesFor (state) {
    return (groupId) => {
      return state.notifications[groupId] && state.notifications[groupId].aggregates
    }
  },
  allIsLoadedFor (state) {
    return (groupId) => {
      return state.notifications[groupId] && state.notifications[groupId].lastTime === null
    }
  }
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/news.js